function guardMyRoute(to, from, next) {
  if (window.localStorage.getItem('token')) next()
  else next('/auth')
}

export default [
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('../views/Auth.vue'),
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home.vue'),
    meta: { title: 'اینوآپ' },
    // beforeEnter: guardMyRoute,
  },
  {
    path: '/flutter-bootcamp',
    name: 'bootcamp',
    component: () => import('../views/flutter-bootcamp.vue'),
    // beforeEnter: guardMyRoute,
  },
  {
    path: '/flutter-course',
    name: 'course',
    component: () => import('../views/flutter-course.vue'),
    // beforeEnter: guardMyRoute,
  },
  {
    path: '/about-us',
    name: 'about',
    component: () => import('../views/about-us.vue'),
    // beforeEnter: guardMyRoute,
  },
  {
    path: '/our-service',
    name: 'service',
    component: () => import('../views/our-service.vue'),
    // beforeEnter: guardMyRoute,
  },
  {
    path: '/scholarship',
    name: 'scholarship',
    component: () => import('../views/scholarship.vue'),
    // beforeEnter: guardMyRoute,
  },
  {
    path: '/company-scholarship',
    name: 'company-scholarship',
    component: () => import('../views/company-scholarship.vue'),
    // beforeEnter: guardMyRoute,
  },
]
